// Несколько правок одной отменой: все транзакции, отправленные внутри fn, попадают в одно событие истории
// (prosemirror-history склеивает транзакции с метой appendedTransaction с предыдущей).
import type { Editor } from '@tiptap/core';
import type { Transaction } from '@tiptap/pm/state';

export function batchEdits<T>(ed: Editor, fn: () => T): T {
  const view: any = ed.view;
  const own = Object.prototype.hasOwnProperty.call(view, 'dispatch') ? view.dispatch : null;
  const orig = view.dispatch.bind(view);
  let first: Transaction | null = null;
  view.dispatch = (tr: Transaction) => {
    if (tr.docChanged) {
      if (first) tr.setMeta('appendedTransaction', first);
      else first = tr;
    }
    orig(tr);
  };
  try {
    return fn();
  } finally {
    if (own) view.dispatch = own; else delete view.dispatch;
  }
}
